import { gql } from '@apollo/client';

export type DispatchEventTaskItem = {
  id: number;
  taskId: number;
  taskWaypointId: number;
  bagId: number | null;
  orderId: number | null;
  operateType: number;
  isOrderFilled: number;
  isCompleted: number;
  hasException: number;
  isOrderCleaned: number;
  operatorAccountId: number;
  createdAt: string | null;
  updatedAt: string | null;
};

export type DispatchEventTaskFilter = {
  id?: number;
  taskId?: number;
  bagId?: number;
  orderId?: number;
  operateType?: number;
  isCompleted?: number;
  hasException?: number;
  isOrderCleaned?: number;
};

export type PageRequest = {
  page: number;
  size: number;
};

export type PagedResult<T> = {
  content: T[];
  page: number;
  size: number;
  totalElements: number;
  totalPages: number;
  hasNext: boolean;
  hasPrevious: boolean;
};

export type DispatchEventTasksResponse = {
  dispatchEventTasks: PagedResult<DispatchEventTaskItem>;
};

export const DISPATCH_EVENT_TASKS = gql`
  query DispatchEventTasks($filter: OpsDispatchEventTaskFilterInput!, $pageRequest: PageRequestTypeInput) {
    dispatchEventTasks(filter: $filter, pageRequest: $pageRequest) {
      content {
        id
        taskId
        taskWaypointId
        bagId
        orderId
        operateType
        isOrderFilled
        isCompleted
        hasException
        isOrderCleaned
        operatorAccountId
        createdAt
        updatedAt
      }
      page
      size
      totalElements
      totalPages
      hasNext
      hasPrevious
    }
  }
`;

export type DispatchEventTaskOrderItem = {
  id: number;
  dispatchEventTaskId: number;
  taskId: number;
  taskWaypointId: number;
  orderId: number;
  bagId: number | null;
  departureEventStatus: number | null;
  arrivedEventStatus: number | null;
  handoverEventStatus: number | null;
  tenderEventStatus: number | null;
  unloadingEventStatus: number | null;
  logscanEventStatus: number | null;
  removalEventStatus: number | null;
  isCompleted: number;
  isSentMq: number;
  retryCount: number;
  exceptionMsg: string | null;
  createdAt: string | null;
  updatedAt: string | null;
};

export type DispatchEventTaskOrderFilter = {
  dispatchEventTaskId?: number;
  orderId?: number;
  bagId?: number;
  isCompleted?: number;
  isSentMq?: number;
  retryCount?: number;
};

export type DispatchEventTaskOrdersResponse = {
  dispatchEventTaskOrders: PagedResult<DispatchEventTaskOrderItem>;
};

export type DispatchEventTaskOrderHistoriesResponse = {
  dispatchEventTaskOrderHistories: PagedResult<DispatchEventTaskOrderItem>;
};

export const DISPATCH_EVENT_TASK_ORDER_HISTORIES = gql`
  query DispatchEventTaskOrderHistories($filter: OpsDispatchEventTaskOrderFilterInput!, $pageRequest: PageRequestTypeInput) {
    dispatchEventTaskOrderHistories(filter: $filter, pageRequest: $pageRequest) {
      content {
        id
        dispatchEventTaskId
        taskId
        taskWaypointId
        orderId
        bagId
        departureEventStatus
        arrivedEventStatus
        handoverEventStatus
        tenderEventStatus
        unloadingEventStatus
        logscanEventStatus
        removalEventStatus
        isCompleted
        isSentMq
        retryCount
        exceptionMsg
        createdAt
        updatedAt
      }
      page
      size
      totalElements
      totalPages
      hasNext
      hasPrevious
    }
  }
`;

export const DISPATCH_EVENT_TASK_ORDERS = gql`
  query DispatchEventTaskOrders($filter: OpsDispatchEventTaskOrderFilterInput!, $pageRequest: PageRequestTypeInput) {
    dispatchEventTaskOrders(filter: $filter, pageRequest: $pageRequest) {
      content {
        id
        dispatchEventTaskId
        taskId
        taskWaypointId
        orderId
        bagId
        departureEventStatus
        arrivedEventStatus
        handoverEventStatus
        tenderEventStatus
        unloadingEventStatus
        logscanEventStatus
        removalEventStatus
        isCompleted
        isSentMq
        retryCount
        exceptionMsg
        createdAt
        updatedAt
      }
      page
      size
      totalElements
      totalPages
      hasNext
      hasPrevious
    }
  }
`;
